import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {MedicalRecordSportModel} from '../model/medicalRecordSport.model';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {
    ConsultationSummaryConverter
} from '../../../../consultation/consultation/api/model/converter/consultationSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class MedicalRecordSportConverter extends HttpModelConverter<MedicalRecordSportModel>{

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private consultationSummaryConverter: ConsultationSummaryConverter) {
        super();
    }
    protected createInstance(): MedicalRecordSportModel {
        return new MedicalRecordSportModel();
    }

    protected enrichObject(result: MedicalRecordSportModel, src: MedicalRecordSportModel) {
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.sport = this.lovValueSummaryConverter.convert(src.sport);
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.frequency = this.lovValueSummaryConverter.convert(src.frequency);
        result.flooring = this.lovValueSummaryConverter.convert(src.flooring);
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
    }

}
